module.exports = __webpack_public_path__ + "static/media/dhangadhi-logo.67da90c0.svg";